<template>
    <div class="m-week" ref="mWeek">
        <div class="m-week__nav" :class="`m-week__nav--day${mobileDay}`">
            <div
                class="m-week__navDay"
                :class="{ 'm-week__navDay--disabled': isDayDisabled(0) }"
                @click="mobileDay = 1"
            >
                Poniedziałek

                <span
                    v-if="packagesAmount(0) > 0"
                    class="m-week__navDayAmount"
                    >{{ packagesAmount(0) }}</span
                >
            </div>
            <div
                class="m-week__navDay"
                :class="{ 'm-week__navDay--disabled': isDayDisabled(1) }"
                @click="mobileDay = 2"
            >
                Wtorek
                <span
                    v-if="packagesAmount(1) > 0"
                    class="m-week__navDayAmount"
                    >{{ packagesAmount(1) }}</span
                >
            </div>
            <div
                class="m-week__navDay"
                :class="{ 'm-week__navDay--disabled': isDayDisabled(2) }"
                @click="mobileDay = 3"
            >
                Środa
                <span
                    v-if="packagesAmount(2) > 0"
                    class="m-week__navDayAmount"
                    >{{ packagesAmount(2) }}</span
                >
            </div>
            <div
                class="m-week__navDay"
                :class="{ 'm-week__navDay--disabled': isDayDisabled(3) }"
                @click="mobileDay = 4"
            >
                Czwartek
                <span
                    v-if="packagesAmount(3) > 0"
                    class="m-week__navDayAmount"
                    >{{ packagesAmount(3) }}</span
                >
            </div>
            <div
                class="m-week__navDay"
                :class="{ 'm-week__navDay--disabled': isDayDisabled(4) }"
                @click="mobileDay = 5"
            >
                Piątek
                <span
                    v-if="packagesAmount(4) > 0"
                    class="m-week__navDayAmount"
                    >{{ packagesAmount(4) }}</span
                >
            </div>
        </div>
        <div class="m-week__days" :class="`m-week__days--day${mobileDay}`">
            <div
                v-for="(day, dayInWeek) in days"
                v-bind:key="dayInWeek"
                class="m-week__day"
                :class="{
                    'm-week__day--alert': isValueMinimum(dayInWeek),
                    'm-week__day--disabled': isDayDisabled(dayInWeek)
                }"
                :data-day-id="dayInWeek"
                @drop="onDrop($event, dayInWeek)"
                @dragover.prevent
            >
                <div class="m-week__dayHeader">
                    <p class="a-title a-title--small">{{ day.name }}</p>
                </div>
                <div
                    v-if="isDayDisabled(dayInWeek)"
                    class="m-week__add m-week__add--top"
                >
                    <svg
                        width="24"
                        height="24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="12" cy="12" r="12" fill="#FEE2E4" />
                        <path
                            d="M10 10v-.75C10 8.007 10.895 7 12 7s2 1.007 2 2.25V10"
                            stroke="#ED535C"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M8 13v-2h8v2a4 4 0 01-8 0z"
                            stroke="#ED535C"
                            stroke-width="2"
                        />
                    </svg>
                </div>
                <button
                    v-else
                    class="m-week__add m-week__add--top"
                    @click="openModalProducts(dayInWeek)"
                >
                    <svg
                        width="24"
                        height="24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="12" cy="12" r="12" fill="#E2E2E2" />
                        <path
                            d="M12.2 8.4V16m-3.8-3.8H16"
                            stroke="#737373"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
                <div
                    v-if="
                        !isValueMinimum(dayInWeek) &&
                            !isDayDisabled(dayInWeek) &&
                            dayOrder(dayInWeek).length === 0
                    "
                    class="m-week__alert m-week__alert--success"
                    @click="openModalProducts(dayInWeek)"
                >
                    <p class="m-week__alertText">
                        Kliknij aby dodać pierwszy produkt
                    </p>
                </div>
                <div
                    class="m-week__dayOrder"
                    v-for="(order, orderIdx) in dayOrder(dayInWeek)"
                    v-bind:key="orderIdx"
                >
                    <product-box
                        :week-day-order="order"
                        :product="order.product"
                        :day-in-week="dayInWeek"
                        :address-id="order.addressId"
                    />
                    <hr class="a-hr" />
                </div>
                <div
                    v-if="dragSamplePackageDayId === dayInWeek"
                    class="m-product m-product--sample"
                >
                    <figure class="m-product__image">
                        <img
                            src="@/assets/pack.jpg"
                            alt="product"
                            class="m-product__imageImg"
                        />
                    </figure>
                    <div>
                        <p class="m-product__title"></p>
                        <div class="m-product__data">
                            <p class="m-product__price"></p>
                            <p class="m-product__amount a-label"></p>
                        </div>
                    </div>
                </div>
                <div class="m-week__alert" v-if="isValueMinimum(dayInWeek)">
                    <p class="m-week__alertText">
                        Minimum logistyczne dostawy to
                        <b>{{ minimumDayValue(dayInWeek) }} zł.</b>
                    </p>
                </div>
                <div
                    class="m-week__alert m-week__alert--disabled"
                    v-if="isDayDisabled(dayInWeek)"
                >
                    <p class="m-week__alertText">
                        W Twojej lokalizacji nie dowozimy tego dnia.
                    </p>
                    <br />
                    <p class="m-week__alertText">
                        <a class="m-week__alertLink" href="tel:+48511056636"
                            >Zadzwoń</a
                        >
                        do nas <br />lub
                        <a
                            class="m-week__alertLink"
                            href="mailto:zapytania@dailyfruits.pl"
                            >wyślij maila</a
                        >
                        i zapytaj o możliwość dostawy.
                    </p>
                </div>
                <div
                    v-if="isDayDisabled(dayInWeek)"
                    class="m-week__add m-week__add--mobile"
                >
                    <svg
                        width="100"
                        height="100"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="50" cy="50" r="50" fill="#fff" />
                        <circle cx="50" cy="50" r="30" fill="#ED535C" />
                        <path
                            d="M43 47v-2.5c0-4.142 3.134-7.5 7-7.5s7 3.358 7 7.5V47"
                            stroke="#fff"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M40.5 48.636c0-.075.061-.136.136-.136h18.728c.075 0 .136.061.136.136V54a9.5 9.5 0 01-19 0v-5.364z"
                            stroke="#fff"
                            stroke-width="3"
                        />
                    </svg>
                </div>
                <button
                    v-else
                    class="m-week__add m-week__add--mobile"
                    @click="openModalProducts(dayInWeek)"
                >
                    <svg
                        width="100"
                        height="100"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="50" cy="50" r="50" fill="#fff" />
                        <circle cx="50" cy="50" r="30" fill="#5DA538" />
                        <path
                            d="M50.5 41v19M41 50.5h19"
                            stroke="#fff"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            </div>
        </div>
        <div
            class="m-week__fixedBar"
            :class="{ 'm-week__fixedBar--absolute': isScrollAtBottom }"
        >
            <div
                v-for="(day, dayInWeek) in days"
                v-bind:key="dayInWeek"
                class="m-week__fixedBarAdd"
            >
                <div
                    v-if="isDayDisabled(dayInWeek)"
                    class="m-week__add m-week__add--fixed"
                >
                    <svg
                        width="100"
                        height="100"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="50" cy="50" r="50" fill="#fff" />
                        <circle cx="50" cy="50" r="30" fill="#ED535C" />
                        <path
                            d="M43 47v-2.5c0-4.142 3.134-7.5 7-7.5s7 3.358 7 7.5V47"
                            stroke="#fff"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M40.5 48.636c0-.075.061-.136.136-.136h18.728c.075 0 .136.061.136.136V54a9.5 9.5 0 01-19 0v-5.364z"
                            stroke="#fff"
                            stroke-width="3"
                        />
                    </svg>
                </div>
                <button
                    v-else
                    class="m-week__add m-week__add--fixed"
                    @click="openModalProducts(dayInWeek)"
                >
                    <svg
                        width="100"
                        height="100"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="50" cy="50" r="50" fill="#fff" />
                        <circle cx="50" cy="50" r="30" fill="#5DA538" />
                        <path
                            d="M50.5 41v19M41 50.5h19"
                            stroke="#fff"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            </div>
        </div>
        <o-notifications name="cart-change" />
        <o-modal name="productRemove">
            <template slot="content" slot-scope="props">
                Czy usunąć produkt
                <strong>{{ props.payload.product.name }}</strong> z koszyka?
                <div class="o-modal__contentButtons">
                    <a-button @click="$store.dispatch('modalHide')"
                        >Nie</a-button
                    >
                    <a-button
                        class="a-button--primary"
                        @click="removeProduct(props.payload)"
                        >Tak</a-button
                    >
                </div>
            </template>
        </o-modal>
    </div>
</template>

<script>
import ProductBox from '@/components/ProductBox'
export default {
    components: {
        ProductBox
    },
    data() {
        return {
            mobileDay: 1,
            isScrollAtBottom: false
        }
    },
    computed: {
        currentAddressId() {
            return this.$store.getters.currentAddressId
        },
        days() {
            return [
                {
                    name: 'Poniedziałek'
                },
                {
                    name: 'Wtorek'
                },
                {
                    name: 'Środa'
                },
                {
                    name: 'Czwartek'
                },
                {
                    name: 'Piątek'
                }
            ]
        },
        weekOrders() {
            return this.$store.getters.weekOrders
        },
        minimumValue() {
            return this.$store.getters.minimumValue
        },
        minimumDayValue(dayInWeek) {
            return this.$store.getters.minimumDayValue
        },
        availibleDays() {
            return this.$store.getters.customerAddressField(
                this.currentAddressId,
                'supportedDays'
            )
        },
        modalProductRemove() {
            return this.$store.getters.modalStatus('productRemove')
        },
        dragSamplePackageDayId() {
            return this.$store.getters.dragSamplePackageDayId
        },
        warehouseId() {
            return this.$store.getters.customerAddressWarehouseId(this.currentAddressId)
        },
        externalSupplier() {
            const warehouse = this.$store.getters.customerAddressField(
                this.currentAddressId,
                'warehouse'
            )
            if (warehouse) {
                return warehouse.external_supplier ? 1 : 0
            } else {
                return 0
            }
        }
    },
    methods: {
        weekDayOrderSumWithoutDiscount(day) {
            return this.$store.getters.weekDayOrderSumWithoutDiscount(
                day,
                this.currentAddressId
            )
        },
        isValueMinimum(dayInWeek) {
            return this.$store.getters.isValueMinimum(
                dayInWeek,
                this.currentAddressId
            )
        },
        isDayDisabled(dayInWeek) {
            if (
                typeof this.availibleDays === 'object' &&
                Object.keys(this.availibleDays).length > 0
            ) {
                return !this.availibleDays.find(
                    item => item.day === dayInWeek + 1
                ).is_active
            } else {
                return false
            }
        },
        openModalProducts(dayInWeek) {
            this.$store.dispatch('modalShow', {
                name: 'products',
                payload: {
                    dayInWeek,
                    addressId: this.currentAddressId,
                    warehouseId: this.warehouseId,
                    externalSupplier: this.externalSupplier
                }
            })
        },
        dayOrder(dayInWeek) {
            return this.$store.getters.weekDayOrder(
                dayInWeek,
                this.currentAddressId
            )
        },
        dayOrderSum(dayInWeek) {
            return this.$store.getters.weekDayOrderSum(
                dayInWeek,
                this.currentAddressId
            )
        },
        removeProduct(payload) {
            this.$store.dispatch('applyProductToCart', {
                dayInWeek: payload.dayInWeek,
                addressId: payload.addressId,
                product: payload.product,
                amount: 0
            })
            this.$store.dispatch('modalHide')
        },
        packagesAmount(dayInWeek) {
            return this.weekOrders.filter(
                item =>
                    item.addressId === this.currentAddressId &&
                    item.dayInWeek === dayInWeek
            ).length
        },
        onDrop($event, dayInWeek) {
            if (!this.isDayDisabled(dayInWeek)) {
                const orderId = $event.dataTransfer.getData('orderId')
                const productId = $event.dataTransfer.getData('productId')
                if (orderId !== '') {
                    const oldAmount = this.weekOrders[orderId].amount
                    const oldAddressId = this.weekOrders[orderId].addressId
                    const oldDayInWeek = this.weekOrders[orderId].dayInWeek
                    const oldProductId = this.weekOrders[orderId].product.id
                    if (dayInWeek !== oldDayInWeek) {
                        // check if already exist
                        const idx = this.weekOrders.findIndex(
                            order =>
                                order.dayInWeek === dayInWeek &&
                                order.product.id === oldProductId
                        )
                        let amount = 0
                        if (idx !== -1) {
                            amount = this.weekOrders[idx].amount
                        }
                        // add to new
                        this.$store.dispatch('applyProductToCart', {
                            dayInWeek: dayInWeek,
                            addressId: this.currentAddressId,
                            product: this.weekOrders[orderId].product,
                            amount: oldAmount + amount
                        })
                        // remove old
                        const toRemoveId = this.weekOrders.findIndex(
                            item =>
                                item.addressId === oldAddressId &&
                                item.dayInWeek === oldDayInWeek &&
                                item.product.id === oldProductId
                        )
                        this.$store.dispatch('applyProductToCart', {
                            dayInWeek: oldDayInWeek,
                            addressId: oldAddressId,
                            product: this.weekOrders[toRemoveId].product,
                            amount: 0
                        })
                    }
                } else if (productId !== '') {
                    // check if already exist
                    const idx = this.weekOrders.findIndex(
                        order =>
                            order.addressId === this.currentAddressId &&
                            order.dayInWeek === dayInWeek &&
                            order.product.id === +productId
                    )
                    let amount = 1
                    if (idx !== -1) {
                        amount = this.weekOrders[idx].amount + 1
                    }
                    this.$store.dispatch('applyProductToCart', {
                        dayInWeek: dayInWeek,
                        addressId: this.currentAddressId,
                        product: this.$store.getters.packageById(
                            +productId,
                            this.currentAddressId
                        ),
                        amount
                    })
                }
            }
            this.$store.dispatch('dragReset')
        },
        handleScroll(event) {
            const scroll = window.pageYOffset + window.innerHeight
            const clientBottom =
                this.$refs.mWeek.offsetHeight + this.$refs.mWeek.offsetTop + 266
            this.isScrollAtBottom = scroll > clientBottom
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll)
        this.isScrollAtBottom = true
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>
